<script setup>
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { message, Modal } from 'ant-design-vue';
import { computed, createVNode, onMounted, ref } from 'vue';
import { useAdminStore } from '../../stores/admin';
const filterClotheName = ref('')
const filterEmail = ref('')

const columns = [
  { title: '編號', dataIndex: '編號', key: '編號', width: 100, fixed: 'left' },
  { title: 'Email', dataIndex: 'Email', key: 'Email'  },
  { title: '上架時間', dataIndex: '上架時間', key: '上架時間' },
  { title: '衣服名稱', key: '衣服名稱', dataIndex: '衣服名稱' },
  { title: '實際售價', key: '實際售價', dataIndex: '實際售價'},
  { title: '售出時間', key: '售出時間', dataIndex: '售出時間' },
  { title: '回饋金', key: '回饋金', dataIndex: '回饋金' },
  { title: '貨號', key: '貨號', dataIndex: '貨號' },
  { title: '顯示在收衣系統的照片', key: '顯示在收衣系統的照片', dataIndex: '顯示在收衣系統的照片'},
  { title: '照片連到官網', key: '照片連到官網', dataIndex: '照片連到官網' },
  { title: '編輯', key: 'action', slots: { customRender: 'actionSlot' }}
];

const AdminStore = useAdminStore()
onMounted(() => {
  AdminStore.queryClothe()
})

const handleClick = () => {
  if (filterClotheName.value || filterEmail.value) AdminStore.queryClothe([{ column: 'Email', value: filterEmail.value }, { column: '衣服名稱', value: filterClotheName.value }])
  else AdminStore.queryClothe()
}

const editRow = ref(null)
const editModalHasShow = computed(() => Boolean(editRow.value))
const edit = id => editRow.value = JSON.parse(JSON.stringify(AdminStore.clotheList[AdminStore.clotheList.map(e => e['編號']).indexOf(id)]))
const handleSubmit = async () => {
  const result = await AdminStore.updateData({ collectionName: 'Clothe', data: { ...editRow.value }})
  console.log(result)
  if (result.state === 'SUCCESS') {
    editRow.value = null
    message.success('已成功修改資料')
  }
}
const handleCancel = () => editRow.value = null
const handleDelete = key => {
  Modal.confirm({
    title: () => '確定要刪除此資料？',
    icon: () => createVNode(ExclamationCircleOutlined),
    cancelText: () => '取消',
    okText: () => '刪除',
    onOk() {
      return new Promise((resolve) => {
        AdminStore.deleteData({ collectionName: 'Clothe', dataKey: key }).then(() => {
          resolve()
          message.success('已成功刪除資料')
        })
      })
    },
    onCancel() {},
  })
}
</script>

<template>
  <div class="view-admin-clothe">
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240)"
      title="衣物案件資料"
      sub-title="衣物處理狀況統計"
    />

    <a-card title="以條件搜尋衣物">
          <a-input v-model:value="filterClotheName">
            <template #addonBefore>
              衣服名稱
            </template>
          </a-input>
          <a-input v-model:value="filterEmail">
            <template #addonBefore>
              使用者 Email
            </template>
          </a-input>

          <a-button type="primary" @click="handleClick">搜尋</a-button>
        </a-card>

    <a-table v-if="AdminStore.clotheList?.length" :columns="columns" :data-source="AdminStore.clotheList" :scroll="{ x: 1000 }">
      <template #saledPercent="{ record }">
        <span>{{ `${record.saled / record.onShelf *100}%` }}</span>
      </template>

      <template #onShelfInfo="{ text }">
        <span>
          {{ text.substring(0, 50) }}
        </span>
      </template>

      <template #actionSlot="{ record }">
        <div>
          <a @click="edit(record['編號'])">修改</a>
          <br>
          <a class="delete-button" @click="handleDelete(record.key)">刪除</a>
        </div>
      </template>
    </a-table>

    <a-modal class="dashboard-edit-modal" :closable="false" v-model:visible="editModalHasShow" title="修改衣服資料" :footer="null">
      <a-form v-if="editRow" :modol="editRow">
        <a-form-item v-for="column in columns.filter(c => c.dataIndex)" :key="column.dataIndex" :label="column.dataIndex">
          <a-input v-model:value="editRow[column.dataIndex]" />
        </a-form-item>
        <a-form-item class="btn-group">
          <a-button style="margin-right: 10px" @click="handleCancel">取消</a-button>
          <a-button type="primary" @click="handleSubmit">修改</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
